export default __webpack_public_path__ + "static/media/sekerbank.fada72bb.png";